import mod from "-!./Register.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Register.js?vue&type=script&lang=js&"